function configCep() {
	/*
	-- Consulta CEP
	*/

	function consulta_cep($cep_elem) {
		var cep = $cep_elem.val();
		var prefixo = $cep_elem.attr('data-cep-campos');

		if($cep_elem.attr('data-cep') == cep) {
			// cep já foi consultado, ignora
			return;
		}

		if(cep.length != 9) {
			//console.log('CEP inválido.');
			return false;
		}

		$cep_elem.parent().append('<small class="cep-carregando">Consultando CEP...</small>')

		$.post(baseurl+'cep', {'cep': cep}, function(data) {
			if(data.status) {
				$('.'+prefixo+'logradouro').val(data.logradouro);
				$('.'+prefixo+'bairro').val(data.bairro);
				$('.'+prefixo+'cidade-id').val(data.cidade_id);
				$('.'+prefixo+'cidade-nome').val(data.localidade+' - '+data.uf);
				$('.'+prefixo+'cidade').val(data.localidade);
				$('.'+prefixo+'estado').val(data.uf);

				$('.'+prefixo+'logradouro').addClass('modificado');
				$('.'+prefixo+'bairro').addClass('modificado');
				$('.'+prefixo+'cidade-nome').addClass('modificado');
				$('.'+prefixo+'cidade').addClass('modificado');
				$('.'+prefixo+'estado').addClass('modificado');

				$cep_elem.attr('data-cep', cep);
			} else {
				console.log('Erro na consulta de CEP.');
				alert('Não foi possível obter os dados para o CEP '+cep+'.');
			}

			$('.cep-carregando').remove();
		});
	}

	$('.consulta-cep').on('keyup change', function() {
		consulta_cep($(this));
	});
}

export default configCep
